class CollectionsTabs extends HTMLElement {
    constructor() {
      super();
      this.detailsList = this.querySelectorAll(".cstm-collections-tabs--details details");
      this.collectionsLists = this.querySelectorAll(".cstm-collections--collection");
      this.collectionsContents = this.querySelector(".cstm-collections-tabs--collections");
      
      this.handleResize = this.handleResize.bind(this);
      this.handleTabClick = this.handleTabClick.bind(this);
      this.mobileClickHandlers = new Map();
    }
  
    connectedCallback() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
      
  
      if (this.detailsList.length > 0) {
        const firstTab = this.detailsList[0].dataset.id;
        this.chooseTab(firstTab);
      }
    }
  
    handleResize() {
      this.removeAllEventListeners();
      
      if (window.innerWidth > 1000) {
        this.setupDesktop();
      } else {
        this.setupMobile();
      }
    }
  
    removeAllEventListeners() {
      this.detailsList.forEach(el => {
        el.removeEventListener('click', this.handleTabClick);
        
        const summary = el.querySelector('summary');
        if (summary && this.mobileClickHandlers.has(el)) {
          summary.removeEventListener('click', this.mobileClickHandlers.get(el));
        }
      });
      this.mobileClickHandlers.clear();
    }
  
    setupDesktop() {
      this.detailsList.forEach(el => {
        el.addEventListener('click', this.handleTabClick);
      });
    }
  
    setupMobile() {
      this.detailsList.forEach(el => {
        const summary = el.querySelector('summary');
        if (summary) {
          const handler = (event) => this.handleMobileTabClick(el, event);
          this.mobileClickHandlers.set(el, handler);
          summary.addEventListener('click', handler);
        }
      });
    }
  
    handleTabClick(event) {
      const el = event.currentTarget;
      const isSummaryClick = event.target.closest && event.target.closest('summary');
      
      if (isSummaryClick && el.hasAttribute('open')) {
        event.preventDefault();
        return;
      }
      
      this.chooseTab(el.dataset.id);
    }
  
    handleMobileTabClick(el, event) {
      event.preventDefault();
      
      const isCurrentlyOpen = el.hasAttribute('open');
      if (isCurrentlyOpen) {
        return;
      }
      
      this.chooseTab(el.dataset.id);
      
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.scrollToEl(el);
        });
      });
    }
  
    chooseTab(id) {
      if (!id) return;
      
      this.detailsList.forEach(el => {
        const isSelected = el.dataset.id === id;
        el.classList.toggle('open', isSelected);
        el.open = isSelected;
      });
      
      this.collectionsLists.forEach(el => {
        el.classList.toggle('open', el.dataset.id === id);
      });
    }
  
    clearOtherOpenDetails(id) {
      if (!id) return;
      
      this.detailsList.forEach(el => {
        if (el.dataset.id !== id) {
          el.open = false;
        }
      });
    }
  
    scrollToEl(el) {
      if (!el) return;
      
      const header = document.querySelector('.cstm-header');
      let offset = 20;
      
      if (header) {
        const headerStyle = window.getComputedStyle(header);
        if (headerStyle.position === 'sticky' || headerStyle.position === 'fixed') {
          offset += header.offsetHeight;
        }
      }
      
      const elementRect = el.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      
      window.scrollTo({
        top: absoluteElementTop - offset,
        behavior: 'smooth'
      });
    }
  }
  
  customElements.define("collections-tabs", CollectionsTabs);